import {
  AUTH_LOGIN, AUTH_LOGOUT, SET_USER_STATE
} from '../mutation-types';
import Vue from 'vue';

// state
const state = () => ({
  invoiceId: null
});

// mutations
const mutations = {};

// actions
const actions = {};

export default {
  state,
  mutations,
  actions,
};
